import { WithGuideLink } from '@mews-commander/types';
import { TextKey } from '@mews-commander/enums';
import { DialogProvider } from '@mews-commander/ui';
import { SettingsLayout } from '../Layout';
import Security from './Security';

const SecurityView: React.FC<WithGuideLink> = ({ guideLink }) => (
    <SettingsLayout guideLink={guideLink} activeTab={TextKey.PrivacyAndSecurity}>
        <DialogProvider>
            <Security />
        </DialogProvider>
    </SettingsLayout>
);

export default SecurityView;
